
import SubscriberValidation from '../mixins/subscriber-validator.js';

const PaymentType = (type) => {
  return {
    mixins: [SubscriberValidation],

    data(){
      return{
        paymentType: 'cash',
        card_type: 'visa',
        r1: false,
        installments: 1,
        r1Data: {
          oib: '',
          city: '',
          name: '',
          address: '',
          postal_code: '',
        }
      }
    },

    methods:{
      setPaymentType(theatreID){
        let context = {
          'payment_type': this.paymentType,
          'card_type': this.card_type,
          'installments': this.installments,
          'status': 'offline_sold',
        }

        if(this.$store.state.isTheatre || this.$store.state.currentTab == 'ticketTheatre') context['performance'] = theatreID;
        else context['subscription'] = theatreID;

        if(this.$store.state.currentTransaction !== null && this.$store.state.currentTransaction.status == 'partner_checkout'){
          context['status'] = 'partner_sold';
        }

        if(this.r1){
          this.passed = false;
          this.requiredFields = ['oib', 'city', 'name', 'address', 'postal_code'];
          this.submited = true;
          this.objectToValidate = JSON.parse(JSON.stringify(this.r1Data));
          this.formSubmitted();
        }
        else this.passed = true;

        if(this.passed){
          if(this.r1){
            context.r1 = this.r1Data;
          }

          if(type == 'fromTheatre'){
            this.$store.dispatch('setActiveTab', 'transactionDetails');
          } else if(type == 'fromBill'){
            this.pay = false;
          }

          if(this.fromPage && !context['subscription']){
            context['isFromPage'] = true;
          }

          if(['cash', 'virman', 'coupon'].includes(this.paymentType)) context['card_type'] = null;

          if(this.$store.state.currentTransaction.kind === 'performance') context.isTicket = true;

          this.$store.dispatch('updateTransaction', {context});
          this.submited = false;

          if(this.fromPage){
            //this.$store.dispatch('setActiveTab', 'performances')
          }
        }
      }
    },
  }
}

export default PaymentType;



// WEBPACK FOOTER //
// ./src/mixins/payment-type.js